import styled from 'styled-components';
import * as Colors from '../../styles/colors';
import { GIVONIC, INTER } from '../../styles/fonts';

export const CaptchaTitle = (styled.span`
  font-family: ${GIVONIC.bold};
  font-weight: 900;
  font-size: 18px;
  line-height: 120%;
  color: ${Colors.PRIMARY};
  margin: 18px 0 6px 0;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const CaptchaContainer = (styled.div<{ width?: number }>`
  width: ${(props: { width?: number }) => props.width ? `${props.width}px` : '100%'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const CaptchaWrapper = (styled.div`
  background-color: ${Colors.GRAYSCALE_200};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  padding-bottom: 18px;
  border-radius: 2px;
  border: 1px solid ${Colors.GRAYSCALE_300};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ImageContainer = (styled.div<{ width?: number; height?: number }>`
  width: 100%;
  height: 220px;
  position: relative;
  background-color: ${Colors.WHITE};
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 1px solid ${Colors.GRAYSCALE_300};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const PuzzlePiece = (styled.div`
  position: absolute;
  z-index: 2;
  pointer-events: none;

  img {
    display: block;
    border-radius: 2px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SliderContainer = (styled.div<{ width?: number }>`
  width: 100%;
  margin-top: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SliderTrack = (styled.div`
  height: 40px;
  background-color: ${Colors.GRAYSCALE_250};
  border-radius: 20px;
  position: relative;
  display: flex;
  align-items: center;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SliderPrompt = (styled.span`
  margin-left: 25%;
  color: ${Colors.GRAYSCALE_400};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Slider = (styled.div<{ $isDragging?: boolean; disabled?: boolean }>`
  width: 60px;
  height: 60px;
  background-color: ${Colors.PALE_BLUE};
  border: 2px solid ${(props: { disabled?: boolean; $isDragging?: boolean }) =>
    props.disabled ? Colors.GRAYSCALE_250 :
      props.$isDragging ? Colors.VIOLET_600 : Colors.GRAYSCALE_250
  };
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  cursor: ${(props: { disabled?: boolean }) => props.disabled ? 'not-allowed' : 'grab'};
  user-select: none;
  transition: ${(props: { $isDragging?: boolean }) => props.$isDragging ? 'none' : 'all 0.2s ease'};
  z-index: 3;

  &:hover {
    border-color: ${(props: { disabled?: boolean }) => props.disabled ? Colors.GRAYSCALE_400 : Colors.VIOLET_600};
    transform: ${(props: { disabled?: boolean }) => props.disabled ? 'none' : 'translateY(-1px)'};
    box-shadow: 0 4px 12px rgba(85, 3, 114, 0.3);
  }

  &:active {
    cursor: ${(props: { disabled?: boolean }) => props.disabled ? 'not-allowed' : 'grabbing'};
    transform: translateY(0);
  }

  ${(props: { $isDragging?: boolean }) => props.$isDragging && `
    cursor: grabbing;
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(85, 3, 114, 0.4);
  `}
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const SliderText = (styled.div`
  color: ${Colors.GREEN_500};
  font-size: 14px;
  font-family: ${INTER.black};
  letter-spacing: 1px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const LoadingContainer = (styled.div<{ height?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props: { height?: number }) => props.height ? `${props.height + 80}px` : '280px'};
  min-height: 260px;
  color: ${Colors.GRAYSCALE_500};
  font-size: 14px;
  background-color: ${Colors.GRAYSCALE_200};
  border-radius: 8px;
  border: 1px solid ${Colors.GRAYSCALE_300};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ErrorMessage = (styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: ${Colors.CRIMSON_500};
  font-size: 14px;
  text-align: center;
  background-color: ${Colors.CRIMSON_100};
  border-radius: 8px;
  border: 1px solid ${Colors.CRIMSON_500};

  button {
    background-color: ${Colors.CRIMSON_500};
    color: ${Colors.WHITE};
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;

    &:hover {
      background-color: ${Colors.CRIMSON_700};
    }
  }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
